// extracted by mini-css-extract-plugin
module.exports = {"button":"ShareButton_button__2wO_K","icon":"ShareButton_icon__3L63Z"};